<router-outlet>
  <feature-toggle-provider [features]="featureFlags"></feature-toggle-provider>
</router-outlet>
<!-- This hidden version is here so we have a way to be able find it on as-top-level-as-possible-->
<div class="version">{{ release }}</div>
